var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26.704 10.192L16.705.293a1.026 1.026 0 00-1.428 0l-9.999 9.9a.994.994 0 000 1.414 1.017 1.017 0 001.429 0l8.275-8.192V31c0 .552.452 1 1.01 1s1.01-.448 1.01-1V3.414l8.275 8.192a1.016 1.016 0 001.428 0 .993.993 0 00-.001-1.414z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgScrollTop;